import callApi from './partials/api';
import store from '@/store';

export default {
    // 取得首頁輪播廣告
    homeCarousel(cb) {
        let companyId = store.getters['advancedSearch/companyId'];
        callApi('get', `Advert/HomeCarousel/${companyId}`, cb);
    },

    // 取得品牌網址
    homeCompanyUrl(companyId, cb) {
        callApi('get', `Advert/HomeCompanyUrl?companyId=${companyId}`, cb);
    },

    // 取得註冊網址
    registerUrl(companyId, cb) {
        callApi('get', `Advert/register-url/${companyId}`, cb);
    },

    // 取得忘記密碼網址
    forgetPwdUrl(companyId, cb) {
        callApi('get', `Advert/forget-pwd-url/${companyId}`, cb);
    }
}
